<template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="dialogShow"
    class="items-no-padding mam-sub-copy-setting sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <sub-master-copy-setting-form
            ref="form"
            :dialog-show="dialogShow"
            :account-mt-id="accountMtId"
            @save-success="successSet"
          ></sub-master-copy-setting-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { setBodyHidden,setBodyNormal } from "@/utils/common";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import subMasterCopySettingForm from "@/components/copyMaster/home/subMasterCopySettingForm";
import { mapGetters } from 'vuex'
export default {
  name: "subMasterCopySettingDialog",
  components: {
    subMasterCopySettingForm,
    VuePerfectScrollbar,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    accountMtId: {}
  },
  data() {
    let _this = this;
    return {
      title: _this.$t('Copy_settings'),
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
    }
  },
  watch: {
    dialogShow(val){
      if(val){
        setBodyHidden();
      }else {
        setBodyNormal();
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    successSet(){
      this.interfaceAjaxSuccess();
    },
    submitHandle(){
      let formCpt = this.$refs.form;
      formCpt.$refs.editform.validate();
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.mam-sub-copy-setting {
  .content {
    padding-top: 30px;
  }
}
</style>
<style lang="scss">
.mam-sub-copy-setting {
  .vs-sidebar--items {

  }
  // 高度滑动有点问题 todo
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }

  .vs-sidebar {
    z-index: 1002;
    position: fixed;
    .sidebar-content {
    }
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }

  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
